import { Action } from '@ngrx/store';
import { type } from '../util';


export const ActionTypes = {
	LOADING: type('[StopoverHotels] loading '),
	PUT_FILTERS: type('[StopoverHotels] put filters'),
	PUT_HOTELS: type('[StopoverHotels] put hotels'),
	PUT_FEATURE_HOTELS: type('[StopoverHotels] put feature_hotels'),
	PUT_STOPOVER: type('[StopoverHotels] put stopover'),
	PUT_CITY_ID: type('[StopoverHotels] put cityID'),
	RESET: type('[StopoverHotels] Reset')
};

export class LoadingAction implements Action {
	type = ActionTypes.LOADING;

	/**
	 *Creates an instance of LoadingAction.
	 * @param {*} [payload]
	 * @memberof LoadingAction
	 */
	constructor(public payload?) { }
}

export class PutStopoverHotelsAction implements Action {
	type = ActionTypes.PUT_HOTELS;


	/**
	 *Creates an instance of PutStopoverHotelsAction.
	 * @param {*} payload
	 * @memberof PutStopoverHotelsAction
	 */
	constructor(public payload?) { }
}

export class PutStopoverFeatureHotelsAction implements Action {
	type = ActionTypes.PUT_FEATURE_HOTELS;


	/**
	 *Creates an instance of PutStopoverFeatureHotelsAction.
	 * @param {*} payload
	 * @memberof PutStopoverFeatureHotelsAction
	 */
	constructor(public payload?) { }
}

export class PutStopoverFiltersAction implements Action {
	type = ActionTypes.PUT_FILTERS;


	/**
	 *Creates an instance of PutStopoverFiltersAction.
	 * @param {*} payload
	 * @memberof PutStopoverFiltersAction
	 */
	constructor(public payload?) { }
}

export class PutStopoverAction implements Action {
	type = ActionTypes.PUT_STOPOVER;

	/**
	 *Creates an instance of PutStopoverAction.
	 * @param {*} payload
	 * @memberof PutStopoverAction
	 */
	constructor(public payload: Object) { }
}

export class PutCityIdAction implements Action {
	type = ActionTypes.PUT_CITY_ID;

	/**
	 *Creates an instance of PutCityIdAction.
	 * @param {*} payload
	 * @memberof PutStopoverAction
	 */
	constructor(public payload: Object) { }
}

export class ResetAction implements Action {
	type = ActionTypes.RESET;
	/**
	 *Creates an instance of ResetAction.
	 * @param {*} [payload]
	 * @memberof ResetAction
	 */
	constructor(public payload?) { }
}

export type Actions =
	LoadingAction |
	PutStopoverHotelsAction |
	PutStopoverFeatureHotelsAction |
	PutStopoverFiltersAction |
	PutStopoverAction |
	PutCityIdAction |
	ResetAction;
